import imag1st from "../../asset/Rectangle 4171 (1).png";
import { useNavigate } from "react-router-dom";

export default function AboutUs1() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-6 sm:px-12 lg:px-20 xl:px-32 2xl:px-48 py-16 sm:py-20 lg:py-24 bg-[#F5F6F7]">
      <div className="max-w-[1920px] 2xl:max-w-[2560px] 4xl:max-w-[3840px] w-full grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-20 2xl:gap-32 items-center">
        
        {/* Left Content Section */}
        <div className="space-y-10 sm:space-y-12 lg:space-y-16">
          <div className="space-y-6">
            <h1 className="font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl 2xl:text-4xl text-[#0A476C]">
              About Us
            </h1>

            <div className="relative">
              <h2 className="font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl 2xl:text-8xl 4xl:text-9xl leading-tight text-[#0A476C]">
                Our
                <br />
                Mission
              </h2>
              <div className="absolute bottom-0 left-0 w-full h-2 bg-[#FC821F] translate-y-2"></div>
            </div>
          </div>

          <p className="max-w-2xl text-base sm:text-lg md:text-xl lg:text-2xl 2xl:text-3xl leading-relaxed font-normal text-[#0A476C]">
            At Belief Marketing Enterprises, our mission is to help law firms grow by delivering{" "}
            <span className="font-bold">exclusive, high-quality motor vehicle accident leads.</span> 
            We believe attorneys should focus on representing clients, not worrying about where the next case will come from.
            <br />
            <br />
            We exist to give law firms a reliable way to scale with compliant, ethical, and results-driven lead generation strategies.
          </p>

          {/* Buttons */}
{/* Buttons */}
<div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
  <button
    onClick={() => navigate("/ContactUs")}
    className="rounded-2xl px-6 py-3 text-base sm:text-lg lg:text-xl font-semibold 
               bg-[#0A476C] text-white border-2 border-[#F4F0E3] 
               transition-colors duration-200 hover:bg-[#F58A26]"
  >
    Get Legal Help
  </button>
  {/* <button
    onClick={() => navigate("/About")}
    className="rounded-2xl px-6 py-3 text-base sm:text-lg lg:text-xl font-semibold 
               bg-[#F5F6F7] text-[#0A476C] border-2 border-[#0A476C] 
               transition-colors duration-200 hover:bg-[#F58A26] hover:text-white hover:border-[#F58A26]"
  >
    About Us
  </button> */}
</div>

        </div>

        {/* Right Image Section */}
        <div className="relative px-4 sm:px-6 lg:px-0">
          <img
            src={imag1st}
            alt="Diverse group of survivors and community members standing together"
            className="w-full h-auto rounded-2xl object-cover shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}
